module.exports = __webpack_public_path__ + "img/image-thumb-21.9656921e.webp";